import { refetch } from "types/Refetch";
import DATA_VARIABLES from "./QUERY_DATA_VARIABLES";
import { QueryDataVariablesVariables } from "./__generated__/QueryDataVariables";

export const refetchDataVariables = refetch<QueryDataVariablesVariables>(
  DATA_VARIABLES
);
